export const REQUEST = 'SurveyShares/REQUEST';
export const SUCCESS = 'SurveyShares/SUCCESS';
export const ERROR = 'SurveyShares/ERROR';

export const SET = 'SurveyShares/SET';
export const DELETED = 'SurveyShares/DELETED';
export const ADDED = 'SurveyShares/ADDED';
